import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { REDUX_STORE_NAME } from "../config/constants";
import storage from "redux-persist/lib/storage";

import rootReducer from "../reducers";

const persistConfig = {
  key: REDUX_STORE_NAME,
  storage,
  whitelist: ["settings"],
};

const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for serializer
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  devTools: import.meta.env.VITE_ENVIRONMENT === "local" ? true : false,
});

export const persistor = persistStore(store)

export default store;
